var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"select"},[_c('span',[_vm._v(_vm._s(_vm.currency.name))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips"},[_c('h3',[_vm._v("Currency")]),_vm._v(" "),_c('p',{staticClass:"text-content"},[_vm._v("Current currency")])])
}]

export { render, staticRenderFns }